/* script */
//
//
//

// Utils
import { cloneDeep } from 'lodash';

// Mixins
import unlayerMixin from 'shared/ui/mixins/unlayer';

// Tools
import countdownTool from './tools/countdown';
import fixedImageTool from './tools/fixed_image';
import gridTool from './tools/grid';
import registerButtonTool from './tools/register_button';

// Constants
import DEFAULT_CONFIG from './registration_unlayer_editor_config.json';

const __vue_script__ = {
    name: 'RegistrationUnlayerEditor',

    mixins: [unlayerMixin],

    props: {
        event: {
            type: Object,
            required: true
        },
        saveSpy: {
            type: Number,
            required: true
        },
        value: {
            type: Object,
            required: true
        },
        mergeTags: {
            type: Object,
            default: () => ({})
        }
    },

    data() {
        return {
            eid: this.event._id,
            containerId: `editor-id-${Date.now()}`,
            editor: null
        };
    },

    watch: {
        saveSpy() {
            this.editor?.exportHtml(({ design, chunks }) => {
                this.$emit('save', { design, html: chunks });
            });
        },
        mergeTags(value) {
            this.setMergeTags(value);
        }
    },

    async mounted() {
        await this.loadUnlayerScript();
        await this.initializeEditor();

        this.setDesign(this.value);
        this.setMergeTags(this.mergeTags);
    },

    methods: {
        async initializeEditor() {
            if (this.editor) {
                return;
            }

            const theme = this.$utils.uiTheme.getCurrentTheme(this.$cookies);
            const config = cloneDeep(DEFAULT_CONFIG);


            this.editor = await new Promise((resolve) => {
                const editor = this.unlayer.createEditor({
                    id: this.containerId,
                    displayMode: 'web',
                    appearance: {
                        theme: `modern_${theme}`
                    },
                    ...config,
                    customJS: [
                        ...config.customJS ?? [],
                        countdownTool,
                        fixedImageTool,
                        gridTool,
                        registerButtonTool
                    ],
                    tools: {
                        ...config.tools,
                        'custom#countdown': {
                            data: {
                                startTime: this.event.description.start_time
                            }
                        }
                    },
                    mergeTags: this.mergeTags
                });

                editor.addEventListener('design:updated', this.handleDesignUpdated);
                editor.registerCallback('image', this.onImageUpload);

                editor.addEventListener('editor:ready', function handleEditorReady() {
                    editor.removeEventListener('editor:ready', handleEditorReady);
                    resolve(editor);
                });
            });
            this.$emit('loaded', true);
        },

        setDesign(value) {
            this.editor?.loadDesign(value);
        },

        setMergeTags(value) {
            this.editor?.setMergeTags(value);
        },

        handleDesignUpdated() {
            this.editor?.exportHtml(({ design }) => {
                this.$emit('input', design);
            });
        }
    }
};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"registration-unlayer-editor",attrs:{"id":_vm.containerId}})}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "RegistrationUnlayerEditor.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__